export const baseUrl: string = "https://api.openweathermap.org/data/2.5";

export const apiKey: string | undefined = process.env.REACT_APP_API_KEY;
